var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSuccessComplete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42279 10L12.6849 12.4444C13.1032 12.7579 13.6924 12.6962 14.0368 12.303L20.4326 5",
    stroke: "#44AF69",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4336 12C21.4336 13.8805 20.844 15.7137 19.7477 17.2423C18.6514 18.7709 17.1033 19.9179 15.3211 20.5224C13.5388 21.1268 11.6118 21.1583 9.81063 20.6125C8.0095 20.0666 6.42476 18.9707 5.27896 17.4789C4.13317 15.987 3.48389 14.174 3.4223 12.2945C3.36072 10.415 3.88993 8.56344 4.93561 6.99987C5.98129 5.4363 7.4909 4.23925 9.25244 3.57685C11.014 2.91444 12.9389 2.81996 14.757 3.30667",
    stroke: "#44AF69",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessComplete);
export default __webpack_public_path__ + "static/media/icon-success-complete.77ec018c87599b95325616b788604c69.svg";
export { ForwardRef as ReactComponent };